/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VisualReference } from './VisualReference';
import {
    VisualReferenceFromJSON,
    VisualReferenceFromJSONTyped,
    VisualReferenceToJSON,
    VisualReferenceToJSONTyped,
} from './VisualReference';
import type { MedicareNursingSpecialCareHigh } from './MedicareNursingSpecialCareHigh';
import {
    MedicareNursingSpecialCareHighFromJSON,
    MedicareNursingSpecialCareHighFromJSONTyped,
    MedicareNursingSpecialCareHighToJSON,
    MedicareNursingSpecialCareHighToJSONTyped,
} from './MedicareNursingSpecialCareHigh';
import type { MedicareNursingClinicallyComplex } from './MedicareNursingClinicallyComplex';
import {
    MedicareNursingClinicallyComplexFromJSON,
    MedicareNursingClinicallyComplexFromJSONTyped,
    MedicareNursingClinicallyComplexToJSON,
    MedicareNursingClinicallyComplexToJSONTyped,
} from './MedicareNursingClinicallyComplex';
import type { MedicareNursingSpecialCareLow } from './MedicareNursingSpecialCareLow';
import {
    MedicareNursingSpecialCareLowFromJSON,
    MedicareNursingSpecialCareLowFromJSONTyped,
    MedicareNursingSpecialCareLowToJSON,
    MedicareNursingSpecialCareLowToJSONTyped,
} from './MedicareNursingSpecialCareLow';
import type { MedicareNursingExtensiveServices } from './MedicareNursingExtensiveServices';
import {
    MedicareNursingExtensiveServicesFromJSON,
    MedicareNursingExtensiveServicesFromJSONTyped,
    MedicareNursingExtensiveServicesToJSON,
    MedicareNursingExtensiveServicesToJSONTyped,
} from './MedicareNursingExtensiveServices';
import type { MedicareNursingOtherSymptoms } from './MedicareNursingOtherSymptoms';
import {
    MedicareNursingOtherSymptomsFromJSON,
    MedicareNursingOtherSymptomsFromJSONTyped,
    MedicareNursingOtherSymptomsToJSON,
    MedicareNursingOtherSymptomsToJSONTyped,
} from './MedicareNursingOtherSymptoms';
import type { MedicareNursingRequiredServices } from './MedicareNursingRequiredServices';
import {
    MedicareNursingRequiredServicesFromJSON,
    MedicareNursingRequiredServicesFromJSONTyped,
    MedicareNursingRequiredServicesToJSON,
    MedicareNursingRequiredServicesToJSONTyped,
} from './MedicareNursingRequiredServices';

/**
 * 
 * @export
 * @interface NursingAssessmentForm
 */
export interface NursingAssessmentForm {
    /**
     * 
     */
    extensive_services?: Array<MedicareNursingExtensiveServices>;
    /**
     * 
     */
    readonly predicted_extensive_services?: Array<MedicareNursingExtensiveServices>;
    /**
     * 
     */
    readonly predicted_extensive_services_reasoning?: string | null;
    /**
     * 
     */
    readonly predicted_extensive_services_visual_references?: Array<VisualReference>;
    /**
     * 
     */
    special_care_high?: Array<MedicareNursingSpecialCareHigh>;
    /**
     * 
     */
    readonly predicted_special_care_high?: Array<MedicareNursingSpecialCareHigh>;
    /**
     * 
     */
    readonly predicted_special_care_high_reasoning?: string | null;
    /**
     * 
     */
    readonly predicted_special_care_high_visual_references?: Array<VisualReference>;
    /**
     * 
     */
    special_care_low?: Array<MedicareNursingSpecialCareLow>;
    /**
     * 
     */
    readonly predicted_special_care_low?: Array<MedicareNursingSpecialCareLow>;
    /**
     * 
     */
    readonly predicted_special_care_low_reasoning?: string | null;
    /**
     * 
     */
    readonly predicted_special_care_low_visual_references?: Array<VisualReference>;
    /**
     * 
     */
    is_depressed?: boolean;
    /**
     * 
     */
    readonly predicted_is_depressed?: boolean;
    /**
     * 
     */
    readonly predicted_is_depressed_reasoning?: string | null;
    /**
     * 
     */
    readonly predicted_is_depressed_visual_references?: Array<VisualReference>;
    /**
     * 
     */
    clinically_complex?: Array<MedicareNursingClinicallyComplex>;
    /**
     * 
     */
    readonly predicted_clinically_complex?: Array<MedicareNursingClinicallyComplex>;
    /**
     * 
     */
    readonly predicted_clinically_complex_reasoning?: string | null;
    /**
     * 
     */
    readonly predicted_clinically_complex_visual_references?: Array<VisualReference>;
    /**
     * 
     */
    other_symptoms?: Array<MedicareNursingOtherSymptoms>;
    /**
     * 
     */
    readonly predicted_other_symptoms?: Array<MedicareNursingOtherSymptoms>;
    /**
     * 
     */
    readonly predicted_other_symptoms_reasoning?: string | null;
    /**
     * 
     */
    readonly predicted_other_symptoms_visual_references?: Array<VisualReference>;
    /**
     * 
     */
    services_required?: Array<MedicareNursingRequiredServices>;
    /**
     * 
     */
    readonly predicted_services_required?: Array<MedicareNursingRequiredServices>;
    /**
     * 
     */
    readonly predicted_services_required_reasoning?: string | null;
    /**
     * 
     */
    readonly predicted_services_required_visual_references?: Array<VisualReference>;
}

/**
 * Check if a given object implements the NursingAssessmentForm interface.
 */
export function instanceOfNursingAssessmentForm(value: object): value is NursingAssessmentForm {
    return true;
}

export function NursingAssessmentFormFromJSON(json: any): NursingAssessmentForm {
    return NursingAssessmentFormFromJSONTyped(json, false);
}

export function NursingAssessmentFormFromJSONTyped(json: any, ignoreDiscriminator: boolean): NursingAssessmentForm {
    if (json == null) {
        return json;
    }
    return {
        
        'extensive_services': json['extensive_services'] == null ? undefined : ((json['extensive_services'] as Array<any>).map(MedicareNursingExtensiveServicesFromJSON)),
        'predicted_extensive_services': json['predicted_extensive_services'] == null ? undefined : ((json['predicted_extensive_services'] as Array<any>).map(MedicareNursingExtensiveServicesFromJSON)),
        'predicted_extensive_services_reasoning': json['predicted_extensive_services_reasoning'] === undefined ? undefined : json['predicted_extensive_services_reasoning'] === null ? null : json['predicted_extensive_services_reasoning'],
        'predicted_extensive_services_visual_references': json['predicted_extensive_services_visual_references'] == null ? undefined : ((json['predicted_extensive_services_visual_references'] as Array<any>).map(VisualReferenceFromJSON)),
        'special_care_high': json['special_care_high'] == null ? undefined : ((json['special_care_high'] as Array<any>).map(MedicareNursingSpecialCareHighFromJSON)),
        'predicted_special_care_high': json['predicted_special_care_high'] == null ? undefined : ((json['predicted_special_care_high'] as Array<any>).map(MedicareNursingSpecialCareHighFromJSON)),
        'predicted_special_care_high_reasoning': json['predicted_special_care_high_reasoning'] === undefined ? undefined : json['predicted_special_care_high_reasoning'] === null ? null : json['predicted_special_care_high_reasoning'],
        'predicted_special_care_high_visual_references': json['predicted_special_care_high_visual_references'] == null ? undefined : ((json['predicted_special_care_high_visual_references'] as Array<any>).map(VisualReferenceFromJSON)),
        'special_care_low': json['special_care_low'] == null ? undefined : ((json['special_care_low'] as Array<any>).map(MedicareNursingSpecialCareLowFromJSON)),
        'predicted_special_care_low': json['predicted_special_care_low'] == null ? undefined : ((json['predicted_special_care_low'] as Array<any>).map(MedicareNursingSpecialCareLowFromJSON)),
        'predicted_special_care_low_reasoning': json['predicted_special_care_low_reasoning'] === undefined ? undefined : json['predicted_special_care_low_reasoning'] === null ? null : json['predicted_special_care_low_reasoning'],
        'predicted_special_care_low_visual_references': json['predicted_special_care_low_visual_references'] == null ? undefined : ((json['predicted_special_care_low_visual_references'] as Array<any>).map(VisualReferenceFromJSON)),
        'is_depressed': json['is_depressed'] == null ? undefined : json['is_depressed'],
        'predicted_is_depressed': json['predicted_is_depressed'] == null ? undefined : json['predicted_is_depressed'],
        'predicted_is_depressed_reasoning': json['predicted_is_depressed_reasoning'] === undefined ? undefined : json['predicted_is_depressed_reasoning'] === null ? null : json['predicted_is_depressed_reasoning'],
        'predicted_is_depressed_visual_references': json['predicted_is_depressed_visual_references'] == null ? undefined : ((json['predicted_is_depressed_visual_references'] as Array<any>).map(VisualReferenceFromJSON)),
        'clinically_complex': json['clinically_complex'] == null ? undefined : ((json['clinically_complex'] as Array<any>).map(MedicareNursingClinicallyComplexFromJSON)),
        'predicted_clinically_complex': json['predicted_clinically_complex'] == null ? undefined : ((json['predicted_clinically_complex'] as Array<any>).map(MedicareNursingClinicallyComplexFromJSON)),
        'predicted_clinically_complex_reasoning': json['predicted_clinically_complex_reasoning'] === undefined ? undefined : json['predicted_clinically_complex_reasoning'] === null ? null : json['predicted_clinically_complex_reasoning'],
        'predicted_clinically_complex_visual_references': json['predicted_clinically_complex_visual_references'] == null ? undefined : ((json['predicted_clinically_complex_visual_references'] as Array<any>).map(VisualReferenceFromJSON)),
        'other_symptoms': json['other_symptoms'] == null ? undefined : ((json['other_symptoms'] as Array<any>).map(MedicareNursingOtherSymptomsFromJSON)),
        'predicted_other_symptoms': json['predicted_other_symptoms'] == null ? undefined : ((json['predicted_other_symptoms'] as Array<any>).map(MedicareNursingOtherSymptomsFromJSON)),
        'predicted_other_symptoms_reasoning': json['predicted_other_symptoms_reasoning'] === undefined ? undefined : json['predicted_other_symptoms_reasoning'] === null ? null : json['predicted_other_symptoms_reasoning'],
        'predicted_other_symptoms_visual_references': json['predicted_other_symptoms_visual_references'] == null ? undefined : ((json['predicted_other_symptoms_visual_references'] as Array<any>).map(VisualReferenceFromJSON)),
        'services_required': json['services_required'] == null ? undefined : ((json['services_required'] as Array<any>).map(MedicareNursingRequiredServicesFromJSON)),
        'predicted_services_required': json['predicted_services_required'] == null ? undefined : ((json['predicted_services_required'] as Array<any>).map(MedicareNursingRequiredServicesFromJSON)),
        'predicted_services_required_reasoning': json['predicted_services_required_reasoning'] === undefined ? undefined : json['predicted_services_required_reasoning'] === null ? null : json['predicted_services_required_reasoning'],
        'predicted_services_required_visual_references': json['predicted_services_required_visual_references'] == null ? undefined : ((json['predicted_services_required_visual_references'] as Array<any>).map(VisualReferenceFromJSON)),
    };
}

export function NursingAssessmentFormToJSON(json: any): NursingAssessmentForm {
    return NursingAssessmentFormToJSONTyped(json, false);
}

export function NursingAssessmentFormToJSONTyped(value?: Omit<NursingAssessmentForm, 'predicted_extensive_services'|'predicted_extensive_services_reasoning'|'predicted_extensive_services_visual_references'|'predicted_special_care_high'|'predicted_special_care_high_reasoning'|'predicted_special_care_high_visual_references'|'predicted_special_care_low'|'predicted_special_care_low_reasoning'|'predicted_special_care_low_visual_references'|'predicted_is_depressed'|'predicted_is_depressed_reasoning'|'predicted_is_depressed_visual_references'|'predicted_clinically_complex'|'predicted_clinically_complex_reasoning'|'predicted_clinically_complex_visual_references'|'predicted_other_symptoms'|'predicted_other_symptoms_reasoning'|'predicted_other_symptoms_visual_references'|'predicted_services_required'|'predicted_services_required_reasoning'|'predicted_services_required_visual_references'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'extensive_services': value['extensive_services'] == null ? undefined : ((value['extensive_services'] as Array<any>).map(MedicareNursingExtensiveServicesToJSON)),
        'special_care_high': value['special_care_high'] == null ? undefined : ((value['special_care_high'] as Array<any>).map(MedicareNursingSpecialCareHighToJSON)),
        'special_care_low': value['special_care_low'] == null ? undefined : ((value['special_care_low'] as Array<any>).map(MedicareNursingSpecialCareLowToJSON)),
        'is_depressed': value['is_depressed'],
        'clinically_complex': value['clinically_complex'] == null ? undefined : ((value['clinically_complex'] as Array<any>).map(MedicareNursingClinicallyComplexToJSON)),
        'other_symptoms': value['other_symptoms'] == null ? undefined : ((value['other_symptoms'] as Array<any>).map(MedicareNursingOtherSymptomsToJSON)),
        'services_required': value['services_required'] == null ? undefined : ((value['services_required'] as Array<any>).map(MedicareNursingRequiredServicesToJSON)),
    };
}

